@if (multi) {
  <ng-container [ngTemplateOutlet]="groupedItem" [ngTemplateOutletContext]="{ $implicit: groupItem$ | async }"> </ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="singleItem" [ngTemplateOutletContext]="{ $implicit: purchaseItem }"> </ng-container>
}

<ng-template #groupedItem let-item>
  <div class="card redeem-card py-3 bg-marketplace-wallet cursor-pointer grouped" [ngClass]="{ 'w-btn': item?.count > 1 }">
    <span class="item-count">x{{ item?.count }}</span>
    <div class="d-flex justify-content-center align-items-center">
      <img
        class="purchase-list-image"
        [src]="item?.items[0].Image | contentImage: '7'"
        alt=""
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <div class="marketplace-wallet-won-item-name purchase-title">{{ item?.items[0].Name }}</div>

    <div class="wallet-item-expiry" *ngIf="item?.items[0].ExpireDate">
      {{ 'fgbcl.wallet.expiry.date' | translate }}
      {{ item?.items[0].ExpireDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
    </div>

    <ng-container *ngTemplateOutlet="attributeTemplate; context: { $implicit: item?.items[0] }"></ng-container>
    <div class="action-wrapper">
      <button class="bg-primary rounded">{{ 'marketplace.purchased.list.item.view.items' | translate }}</button>
    </div>
  </div>
</ng-template>

<ng-template #singleItem let-item>
  <ng-container *ngIf="item">
    @if (!redeemed) {
      <ng-container *ngIf="orientation === 'portrait'">
        <ng-container *ngTemplateOutlet="portrait; context: { $implicit: item }"></ng-container>
      </ng-container>

      <ng-container *ngIf="orientation === 'landscape'">
        <div class="d-none d-lg-flex">
          <ng-container *ngTemplateOutlet="landscape; context: { $implicit: item }"></ng-container>
        </div>
        <div class="d-lg-none d-flex">
          <ng-container *ngTemplateOutlet="portrait; context: { $implicit: item }"></ng-container>
        </div>
      </ng-container>
    } @else if (redeemed) {
      <div class="wallet-container redeemed-border p-3 cursor-pointer">
        <div class="row">
          <div class="col-lg-1 col-2">
            <img
              class="purchase-list-image"
              [src]="item.Image | contentImage: '7'"
              alt=""
              [useDefault]="true"
              [loyaltyType]="'marketplace'"
              draggable="false"
            />
          </div>
          <div class="col-lg-11 col-10">
            <div class="ms-lg-0 ms-3 d-flex flex-column justify-content-between h-100">
              <div class="wallet-marketplace-item-name font-size-14">{{ item.Name }}</div>
              @if (item.RedeemDate) {
                <div class="marketplace-wallet-claimed">
                  {{ 'fgbcl.wallet.claimed' | translate }} {{ item.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
                </div>
              } @else if (expired()) {
                <fgbcl-expired-pill [ExpirationDate]="item.ExpireDate"></fgbcl-expired-pill>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </ng-container>
</ng-template>

<ng-template #portrait let-item>
  <div
    class="card redeem-card py-3 bg-marketplace-wallet cursor-pointer"
    [ngClass]="{
      redeemed: item?.RedeemDate || expired(),
      'w-btn': showButton,
      'unique-link': isUniqueCodeLink,
      'unique-text': item.MarketplaceItemType == ProcessProvider.UniqueCode,
      download: item.MarketplaceItemType == ProcessProvider.Download,
    }"
  >
    <div class="d-flex justify-content-center align-items-center">
      <img
        class="purchase-list-image"
        [src]="item.Image | contentImage: '7'"
        alt=""
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <div class="marketplace-wallet-won-item-name purchase-title">{{ item.Name }}</div>

    @if (item?.RedeemDate) {
      <div class="marketplace-wallet-claimed">
        {{ 'fgbcl.wallet.claimed' | translate }} {{ item.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
      </div>
    } @else if (expired()) {
      <fgbcl-expired-pill [ExpirationDate]="item.ExpireDate"></fgbcl-expired-pill>
    } @else {
      <!--Expiration Date-->
      <ng-container *ngIf="item.ExpireDate">
        <div class="marketplace-wallet-expiry pt-0">
          {{ 'fgbcl.wallet.expiry.date' | translate }}
          {{ item.ExpireDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
        </div>
      </ng-container>

      <!--Barcode-->
      <ng-container
        *ngIf="
          item.MarketplaceItemType != ProcessProvider.UniqueCode &&
          item.MarketplaceItemType != ProcessProvider.VirtualEvent &&
          item.MarketplaceItemType != ProcessProvider.Download
        "
      >
        <ng-container *ngIf="item.Barcode">
          <div class="d-block d-lg-none mt-auto">
            <div class="qrcode-container">
              @if (!showButton) {
                <qrcode
                  [qrdata]="item.Barcode"
                  [width]="116"
                  [errorCorrectionLevel]="'M'"
                  [elementType]="'svg'"
                  [margin]="0"
                ></qrcode>
              } @else {
                <qrcode
                  [qrdata]="item.Barcode"
                  [width]="83"
                  [errorCorrectionLevel]="'M'"
                  [elementType]="'svg'"
                  [margin]="0"
                ></qrcode>
              }
            </div>
            @if (!showButton) {
              <span class="marketplace-scan-text">{{ 'marketplace.purchased.list.item.scan.text' | translate }}</span>
            }
          </div>
        </ng-container>

        <ng-container *ngIf="!item.Barcode">
          <div class="my-3 d-block d-lg-none">
            <div class="marketplace-no-barcode fw-bold font-size-12 text-center p-2">
              {{ 'fgbcl.rewards.wallet.marketplace.no.barcode' | translate }}
            </div>
          </div>
        </ng-container>

        @if (showButton) {
          <ng-container *ngTemplateOutlet="attributeTemplate; context: { $implicit: item }"></ng-container>
          <div class="action-wrapper d-none d-lg-flex">
            <button class="bg-primary rounded marketplace-wallet-view-btn">
              <span class="font-size-14">{{ 'view.rewards.item' | translate }}</span>
            </button>
          </div>
        } @else {
          <div class="action-wrapper d-none d-lg-flex">
            <span class="marketplace-claim-text">{{ 'marketplace.purchased.list.item.claim.text' | translate }}</span>
          </div>
        }
      </ng-container>
      <!--Unique Code-->
      <ng-container *ngIf="item.MarketplaceItemType == ProcessProvider.UniqueCode">
        @if (item.WalletDisplayType1 == WalletDisplayType.Hidden) {
        } @else if (item.WalletDisplayType1 == WalletDisplayType.Barcode) {
          <div class="d-block d-lg-none mt-auto">
            <div class="qrcode-container">
              <qrcode [qrdata]="item.Code" [width]="83" [errorCorrectionLevel]="'M'" [elementType]="'svg'" [margin]="0"></qrcode>
            </div>
          </div>

          <div class="action-wrapper d-none d-lg-flex">
            <button class="bg-primary rounded marketplace-wallet-view-btn">
              <span class="font-size-14">{{ 'view.rewards.item' | translate }}</span>
            </button>
          </div>
        } @else if (item.WalletDisplayType1 == WalletDisplayType.Link) {
          <div class="action-wrapper">
            <a
              [href]="item.Code"
              (click)="$event.stopPropagation()"
              class="btn-unique-code d-flex align-items-center justify-content-center"
            >
              <span> {{ 'wallet.open.link' | translate }}</span>
            </a>
          </div>
        } @else if (item.WalletDisplayType1 == WalletDisplayType.Text) {
          <div class="action-wrapper flex-row justify-content-center">
            <div class="wallet-unique-code-item text-center">{{ item.Code }}</div>

            <span class="wallet-copy-icon material-symbols-outlined" (click)="copyToClipboard(item.Code)">content_copy </span>
          </div>

          <span class="enter-code-text">
            @if (item?.Code2) {
              {{ 'wallet.enter.codes.text' | translate }}
            } @else {
              {{ 'wallet.enter.code.text' | translate }}
            }
          </span>
        } @else if (item.WalletDisplayType1 == WalletDisplayType.BarcodeText) {
          <div class="action-wrapper">
            <span class="marketplace-claim-text">
              <div class="d-block d-lg-none mt-auto">
                <div class="qrcode-container">
                  <qrcode
                    [qrdata]="item.Code"
                    [width]="83"
                    [errorCorrectionLevel]="'M'"
                    [elementType]="'svg'"
                    [margin]="0"
                  ></qrcode>
                </div></div
            ></span>

            <div class="wallet-unique-code-item w-100 text-center">{{ item.Code }}</div>
          </div>
        }

        <div class="wallet-unique-code-item w-100 text-center d-block d-lg-none" *ngIf="item?.Code2">{{ item.Code2 }}</div>
      </ng-container>

      <!--Download-->
      <ng-container *ngIf="item.MarketplaceItemType == ProcessProvider.Download">
        <div class="action-wrapper">
          <button
            class="bg-primary rounded marketplace-wallet-download-btn"
            (click)="$event.stopPropagation(); downloadPurchasedItem(item.LogId)"
          >
            <span class="font-size-14">{{ 'download.rewards.item' | translate }}</span>
          </button>
        </div>
      </ng-container>
    }
  </div>
</ng-template>

<ng-template #attributeTemplate let-item>
  <!-- Attribute -->
  <ng-container *ngIf="item.Attributes?.length > 0">
    <div class="item-attributes" *ngFor="let attribute of item.Attributes; let i = index">
      <div class="item-attribute">
        {{ attribute.DisplayName }}:&nbsp;
        @switch (attribute.DisplayType) {
          @case (attributeDisplayType.Date) {
            <span
              fgbclAttributeTransValue
              [isWallet]="true"
              [attributeList]="item.Attributes"
              [attributeDataOrId]="attribute.LogId"
            >
            </span>
          }
          @default {
            {{ attribute.DisplayValue }}
          }
        }
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #landscape let-item>
  <div class="card wallet-item-card">
    <div class="wallet-item-card-details">
      <img [src]="item.Image | contentImage: '7'" alt="" [useDefault]="true" [loyaltyType]="'wallet'" draggable="false" />
      <div class="wallet-item-details">
        <div class="wallet-item-title">{{ item.Name }}</div>

        @if (item?.RedeemDate) {
          <div class="marketplace-wallet-claimed">
            {{ 'fgbcl.wallet.claimed' | translate }} {{ item.RedeemDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
          </div>
        } @else if (expired()) {
          <fgbcl-expired-pill [ExpirationDate]="item.ExpireDate"></fgbcl-expired-pill>
        } @else {
          <!--Expiration Date-->
          <ng-container *ngIf="item.ExpireDate">
            <div class="wallet-item-expiry">
              {{ 'fgbcl.wallet.expiry.date' | translate }}
              {{ item.ExpireDate | UtcToLocaltimePipe: dateOption.LongDateFormat }}
            </div>
          </ng-container>
        }
      </div>
    </div>
    <div class="action-buttons" *ngIf="!item?.RedeemDate && !expired()">
      @if (item.MarketplaceItemType == ProcessProvider.Download) {
        <button
          class="bg-primary rounded marketplace-wallet-download-btn"
          (click)="$event.stopPropagation(); downloadPurchasedItem(item.LogId)"
        >
          <span class="font-size-14">{{ 'download.rewards.item' | translate }}</span>
        </button>
      } @else if (item.MarketplaceItemType == ProcessProvider.UniqueCode) {
        @if (item.WalletDisplayType1 == WalletDisplayType.Hidden) {
        } @else if (item.WalletDisplayType1 == WalletDisplayType.Barcode) {
          <span class="marketplace-claim-text">{{ 'marketplace.purchased.list.item.claim.text' | translate }}</span>
        } @else if (item.WalletDisplayType1 == WalletDisplayType.Link) {
          <a
            [href]="item.Code"
            (click)="$event.stopPropagation()"
            class="btn-unique-code d-flex align-items-center justify-content-center"
          >
            <span> {{ 'wallet.open.link' | translate }}</span>
          </a>
        } @else if (item.WalletDisplayType1 == WalletDisplayType.Text) {
          <div class="d-flex gap-2">
            <div class="wallet-unique-code-item w-100 text-center">{{ item.Code }}</div>
            <span class="wallet-copy-icon material-symbols-outlined" (click)="copyToClipboard(item.Code)">content_copy </span>
          </div>
          <span class="enter-code-text">
            @if (item?.Code2) {
              {{ 'wallet.enter.codes.text' | translate }}
            } @else {
              {{ 'wallet.enter.code.text' | translate }}
            }
          </span>
        } @else if (item.WalletDisplayType1 == WalletDisplayType.BarcodeText) {
          <span class="marketplace-claim-text">{{ 'marketplace.purchased.list.item.claim.text' | translate }}</span>

          <div class="wallet-unique-code-item w-100 text-center">{{ item.Code }}</div>
        }

        <div class="wallet-unique-code-item w-100 text-center" *ngIf="item?.Code2">{{ item.Code2 }}</div>
      } @else {
        <span class="marketplace-claim-text">{{ 'marketplace.purchased.list.item.claim.text' | translate }}</span>
      }
    </div>
  </div>
</ng-template>
